import { FC, useEffect, useState } from "react";
import { Collapse, Spin } from "antd";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import CustomTooltip from "@pages/tool-tip";
// import { spacedString} from "@pages/utils/utils";
import Icon from "@assets/icon_config";
import "./housing-and-nutrition.scss";
import { SDImageCard, SDTextCard, SDProgressCard, SDPentagonCard } from "../card";
import {getDisplayValueBasedOnType as getDisplayValue} from "@utils/helpers";
import { cloneDeep } from 'lodash'
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const { Panel } = Collapse;

const HousingAndNutrition: FC<any> = (props) => {
  const dataCardId = "10";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : [])

  useEffect(()=>{
    console.log("HousingAndNutrition.useEffect");
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  }, [props.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  }

  // const housingAndNutritionData = props?.data?.housingAndNutritionInfo
  //   ? Object.entries(props?.data.housingAndNutritionInfo).map(([key, val]) => ({ type: spacedString(key), value: val }))
  //   : [];
  const genExtra = (id:any) => <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds}/>

  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{ margin: "8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );
  return (
    <Collapse
      accordion
      activeKey={activeCardPanel}
      expandIconPosition="right"
      bordered={false}
      onChange={onCollapseChange}
    >
      <Panel
        className="title ui-housing"
        header={getHeading("Housing And Nutrition")}
        key="1"
        extra={genExtra(props?.data?.datacardId)}
        style={{marginBottom: "8px"}}
      >
        
        <div className='ui-housing__card-items'>
          <SDTextCard
            title="Member Distance To Assigned PCP"
            text={props?.data?.memberDistanceToPCP}
            subtext={'Miles'}
          />
          <SDImageCard
            title="House Owner"
            image={<Icon name={"houseOwner"} />}
            value={getDisplayValue(props?.data?.houseOwner , 'percent')}
          />
          <SDImageCard
            title="Mobile Homes"
            image={<Icon name={"mobilePhones"} />}
            value={getDisplayValue(props?.data?.mobileHomes , 'percent')}
          />
          <SDImageCard
            title="Food Stamps"
            image={<Icon name={"foodStamps"} />}
            value={getDisplayValue(props?.data?.foodStamps , 'percent')}
          />
          <SDImageCard
            title="Overcrowded Houses"
            image={<Icon name={"overcrowdedHouses"} />}
            value={getDisplayValue(props?.data?.overcrowdedHouses , 'percent')}
          />
          <SDPentagonCard
            title="Household Size More Than One"
            value={props?.data?.householdSizeMoreThanOne}
          />
          <SDProgressCard
            title="Civillian With A Disability"
            value={props?.data?.civilianWithADisability}
          />
        </div> 
      </Panel>
    </Collapse>
  );
};

export default HousingAndNutrition;
